// Trigger staging deploy from main
import React from "react";
import ReactDOM from "react-dom";
import "lazysizes";

import AppWrapper from "ui/AppWrapper";

ReactDOM.render(React.createElement(AppWrapper), document.getElementById("root"));
